import { computed, ref } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

const userViewScope = ref(null);

/**
 * Composable to determine if the current user is an administrator.
 * @returns {Boolean} - True if the current user is an administrator, false otherwise.
 */
export function useAdmin() {
  const getters = useStoreGetters();

  const currentUserRole = computed(() => getters.getCurrentRole.value);
  const isAccountAdmin = computed(
    () => currentUserRole.value === 'administrator'
  );
  const scope = computed(
    () =>
      `${getters.getCurrentUserID?.value}:${getters.getCurrentAccountId?.value}`
  );
  const isUserView = computed(
    () => isAccountAdmin.value && userViewScope.value === scope.value
  );
  const isAdmin = computed(() => isAccountAdmin.value && !isUserView.value);
  const toggleUserView = () => {
    if (isAccountAdmin.value)
      userViewScope.value = isUserView.value ? null : scope.value;
  };

  return {
    isAdmin,
    isAccountAdmin,
    isUserView,
    toggleUserView,
  };
}
